import React, { useEffect, useState } from "react";
import Lottie from "react-lottie-player";

import lottieJson from "assets/json/lottie.json";

export default function LottieTest() {
  if (!lottieJson) return <div>Loading...</div>;
  return (
    <Lottie
      loop
      animationData={lottieJson}
      play
      style={{ width: 150, height: 150 }}
    />
  );
}
